import React, {  useEffect } from 'react';
import { Switch, Route, useHistory, useLocation } from 'react-router';

import AdminMain from './page/admin/Main';
import CoachMain from './page/coach/Main';
import ChannelMain from './page/channel/Main';
import Share from './page/Share';
import SignIn from './page/SignIn';
import { login } from './utils/api';

function App() {
  const location = useLocation()
  const history = useHistory()
  useEffect(() => {
    login().then(res => {
      const status = res.data
      if (location.pathname.startsWith('/share/')) {
        console.info(location.pathname)
        return;
      }
      if (status) {
        localStorage.setItem('user', status)
      } else {
        localStorage.removeItem('user')
        history.push('/signin')
      }
    })
  }, [])

  return (
    <div>
      <Switch>
        <Route path="/admin">
          <AdminMain />
        </Route>
        <Route path="/coach">
          <CoachMain />
        </Route>
        <Route path="/channel">
          <ChannelMain />
        </Route>
        <Route path="/share/:id">
          <Share />
        </Route>
        <Route path={['/signin', '*']}>
          <SignIn />
        </Route>
      </Switch>
    </div>
  );
}

export default App;
